import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer'

/**
 * Component movements specification for desktop
 * @params {object} - react props
 * @returns {JSX}
 */
export const MovementsDesktop = props => {

    const
        {
            section,
            teeth,
            spe,
            jaw,
            setJaw,
            getNumeric,
            getTpJaw,
            mvt
        } = props

    return (
        <section className="specsDesktop movements">
            <div className="SpecificationMember">
                {mvt.map( jawId =>
                    <div className={(jaw === getTpJaw(jawId).name) ? "selected" : null} onClick={() => setJaw(getTpJaw(jawId).name)} key={jawId}>
                        {ihm_viewer__dictionary[getTpJaw(jawId).TRANS][locale()]}
                    </div>
                )}
            </div>
            <table>
                <tbody>
                    <tr>
                        { section.map( sect =>
                            <td  className="SpecificationTooth" key={sect}>
                                <h3>{ihm_viewer__dictionary['SPE_'+sect][locale()]}</h3>
                                <table>
                                    <thead>
                                        <tr>
                                        <th></th>
                                        { teeth[jaw].map(item => <th key={item+'mvt'}>{item}</th> )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        spe.map( special => <tr key={special+'line'}>
                                            <td key={special+'title'} className="label">
                                                {ihm_viewer__dictionary.SPE_MOVEMENTS_ITEMS[special.toUpperCase()][locale()]}
                                            </td>
                                            { teeth[jaw].map( tooth =>
                                                <td key={special+tooth}>
                                                    { getNumeric( sect, special, tooth, 'mvts' ) }
                                                </td>
                                            ) }
                                        </tr>
                                    ) }
                                    </tbody>
                                </table>
                            </td>
                        )}
                    </tr>
                </tbody>
            </table>
        </section>
    )
}
